import React,{ useEffect, useContext, useState, useRef } from "react";
// Components
import { Header } from "../../components/Landing/Header/haeder.view";
import { HeaderScc } from "../../components/Landing/Header/headerScc";
import { BreadCrumb } from "../../components/Landing/Breadcrumb/breadcrumb.view";
import { Cards } from "./components/Cards/cards";
import { ModalVisualizarInversion } from "../Landing/components/ModalVisualizarInversion";
import {ModalAvisoInfo} from "../Landing/components/ModalAvisoInfo";
import {
  SearchOutlined,
  EyeOutlined
} from "@ant-design/icons";
import { Footer } from "../../components/Landing/Footer";
import { Buttonloadmore } from "../../components/Landing/Buttonloadmore";
import { Banner } from "./components/Banner/Banner";
import { Carousel } from "./components/Carousel/Carousel";
import { useNavigate } from "react-router-dom";
import getStorageUser from "../../middlewares/GetStorageUser"
import { Form, Select, Input, Button, Collapse, Table, Empty, Row, Col, Popover, Space, Carousel as AntdCarousel } from "antd";
import { ReactComponent as FlechaSelect } from "../../assets/flecha_select.svg";
import { QuienParticipaOptions, tipoConvocatoria } from "../../utils/dataSelectOptions";
import { EntidadOptions, tipoEntidad } from "../../utils/dataSelectOptions";
import { TemplateContext } from "../../utils/template_context";
import apiMaestras from "../../api/Maestras/api-maestras";
import PersonCard from './components/Cards/PersonCard';
import './PeopleList.scss';
import Comuna1 from "../../assets/comunas/Mapa de Medellin y comunas individuales_1.svg"
import Comuna2 from "../../assets/comunas/Mapa de Medellin y comunas individuales_2.svg"
import Comuna3 from "../../assets/comunas/Mapa de Medellin y comunas individuales_3.svg"
import Comuna4 from "../../assets/comunas/Mapa de Medellin y comunas individuales_4.svg"
import Comuna5 from "../../assets/comunas/Mapa de Medellin y comunas individuales_5.svg"
import Comuna6 from "../../assets/comunas/Mapa de Medellin y comunas individuales_6.svg"
import Comuna7 from "../../assets/comunas/Mapa de Medellin y comunas individuales_7.svg"
import Comuna8 from "../../assets/comunas/Mapa de Medellin y comunas individuales_8.svg"
import Comuna9 from "../../assets/comunas/Mapa de Medellin y comunas individuales_9.svg"
import Comuna10 from "../../assets/comunas/Mapa de Medellin y comunas individuales_10.svg"
import Comuna11 from "../../assets/comunas/Mapa de Medellin y comunas individuales_11.svg"
import Comuna12 from "../../assets/comunas/Mapa de Medellin y comunas individuales_12.svg"
import Comuna13 from "../../assets/comunas/Mapa de Medellin y comunas individuales_13.svg"
import Comuna14 from "../../assets/comunas/Mapa de Medellin y comunas individuales_14.svg"
import Comuna15 from "../../assets/comunas/Mapa de Medellin y comunas individuales_15.svg"
import Comuna16 from "../../assets/comunas/Mapa de Medellin y comunas individuales_16.svg"
import Comuna70 from "../../assets/comunas/Mapa de Medellin y comunas individuales_altavista.svg"
import Comuna80 from "../../assets/comunas/Mapa de Medellin y comunas individuales_san antonio de prado.svg"
import Comuna90 from "../../assets/comunas/Mapa de Medellin y comunas individuales_sta elena.svg"
import Comuna60 from "../../assets/comunas/Mapa de Medellin y comunas individuales_san cristobal.svg"
import Comuna50 from "../../assets/comunas/Mapa de Medellin y comunas individuales_san sebastian de palmitas.svg"
import Inversion from "../../assets/comunas/Mapa-de-Medellin-Cifras_Convocatorias---movil-vertical.jpg"
import Rio from "../../assets/comunas/río-28.svg"
import InversionArea from "../../assets/comunas/inversionporarea.png"
import mapaCifras from "../../assets/comunas/mapaCifras.png"
import InternoMov from "../../assets/landing/IMG_2765.MOV"
import InternoMov2 from "../../assets/landing/IMG_2766.MOV"

import abc1 from "../../assets/landing/abc/abc1.jpg"
import abc2 from "../../assets/landing/abc/abc2.jpg"
import abc3 from "../../assets/landing/abc/abc3.jpg"
import abc4 from "../../assets/landing/abc/abc4.jpg"
import abc5 from "../../assets/landing/abc/abc5.jpg"
import abc6 from "../../assets/landing/abc/abc6.jpg"
import abc7 from "../../assets/landing/abc/abc7.jpg"

import creativa from "../../assets/landing/landing_animado.gif"


// Hook
import { useLanding } from "../../hooks/useLanding";
// style
import "./landing.style.scss";
import { color } from "html2canvas/dist/types/css/types/color";
import { borderBottomStyle } from "html2canvas/dist/types/css/property-descriptors/border-style";
import { relative } from "path";

const routes = [
  { icon: <></>, nombre: "Alcaldía de Medellín" },
  { icon: <></>, nombre: "Secretaría de Cultura Ciudadana" },
  { icon: <></>, nombre: "Convocatoria de Fomento y Estímulos para el Arte y la Cultura" },
];
const coloresEstado = {
  Abierta: "#21BA45",
  "En espera": "#EFC236",
  Cerrada: "#9F0505",
};
const { Panel } = Collapse;

const blockquoteStyle = {
  background: '#FFF',
  border: 0,
  margin: '1px',
  padding: 0,
  boxShadow: 'none',
  display: 'block'
};

const divStyle = {
  padding: '16px'
};

const linkStyle = {
  color: '#000',
  fontFamily: 'Arial, sans-serif',
  fontSize: '14px',
  fontStyle: 'normal',
  fontWeight: 'normal',
  lineHeight: '17px',
  textDecoration: 'none'
};

const divCarrusel = {
  backgroundColor: '#efefef',
  padding: '20px',
  borderRadius: '10px'
}

export const Landing = () => {
  // state component
  const {
    principalState,
    getConvocatorias,
    getSiguientesConvocatorias,
    visibleButton,
    setPrincipalState,
    buscarconvocatorias,
    limipiarfiltros,
    loadingConvocatorias
  } = useLanding();

  const navigate = useNavigate();

  React.useEffect(() => {
    getLineasConvocatorias();
  }, []);

  useEffect(() => {
    // Crear un script y añadirlo al DOM
    const script = document.createElement('script');
    script.src = '//www.instagram.com/embed.js';
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);

    // Limpiar el script cuando el componente se desmonte
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const context = useContext(TemplateContext);
  const [LineasConvocatorias, setLineasConvocatorias] = React.useState([]);
  const [mostrarTabla, setMostrarTabla] = useState(false);

  const toggleVista = () => {
    setMostrarTabla(!mostrarTabla);
  };

  const getLineasConvocatorias = async () => {
    const data = await apiMaestras.obtenerLineaConvocatoria();
    setLineasConvocatorias(data);
  }

  const getFilterLineaConvocatoria = (idLineaConvocatoria, data) => {
    const valueFilter = LineasConvocatorias.filter((x) => x.id === idLineaConvocatoria);
    if (valueFilter[0] !== undefined && valueFilter[0].nombre !== undefined) {
      return valueFilter[0].nombre;
    } else {
      if (data.nombre_convocatoria && data.nombre_convocatoria.includes("jurados")) {
        return "Banco de Jurados";
      } else {
        return "BEPS";
      }
    }
  };

  const fields = [
    { name: "perfil_participante", value: principalState.buscarconvocatorias.perfil_participante },
    { name: "area", value: principalState.buscarconvocatorias.area },
    { name: "entidad", value: principalState.buscarconvocatorias.entidad },
    { name: "linea_convocatoria", value: principalState.buscarconvocatorias.linea_convocatoria },
    { name: "categoria_linea_convocatoria", value: principalState.buscarconvocatorias.categoria_linea_convocatoria },
    { name: "buscar_palabra_clave", value: principalState.buscarconvocatorias.buscar_palabra_clave },
    { name: "tipo_convocatoria", value: principalState.buscarconvocatorias.tipo_convocatoria },
    { name: "anio", value: principalState.buscarconvocatorias.anio },
 ];

  const datosTabla = principalState.convocatoriasslice
    .filter((data: any) => data.entidad !== "SM" && data.entidad !== "MCM" && data.entidad !== "PP" && data.entidad !== "AGENDA CULTURAL")
    .sort((a: any, b: any) => b.idconvocatorias - a.idconvocatorias)
    .map((data: any) => ({
      // Mapear aquí los datos que quieres mostrar en la tabla
      idconvocatorias: data.idconvocatorias,
      nombre_convocatoria: data.nombre_convocatoria,
      fechas: data.fechas,
      estado: data.estado,
      entidad: data.entidad,
      linea_convocatoria: data.linea_convocatoria,
      tipo_participante: data.tipo_participante,
      area: data.area
    }));

  const columns = [
    {
      title: "Nombre convocatoria",
      width: 300,
      dataIndex: "nombre_convocatoria",
      key: "nombre_convocatoria",
      render: (datos) => {
        return (
          <span style={{whiteSpace: "pre-line"}}>
            {datos}
          </span>
        );
      },
    },
    {
      title: "Línea convocatoria",
      width: 450,
      render: (datos) => {
        return (
          <span style={{ fontFamily: "Montserrat-Regular", whiteSpace: "pre-line" , fontWeight: "bold"}}>
            {getFilterLineaConvocatoria(datos?.linea_convocatoria, datos) !== undefined ? `${getFilterLineaConvocatoria(datos?.linea_convocatoria, datos)}` : ""}
          </span>
        );
      },
    },
    {
      title: "Fecha apertura",
      width: 120,
      render: (datos) => {
        let fecha = datos.fechas;
        if (Array.isArray(datos.fechas)) {
          let fechaapertura = datos.fechas.filter(
            (data) => data.clave === "Apertura"
          );
          if (fechaapertura.length > 0) {
            fecha = fechaapertura[0].valormin.substring(0, 10);
          }
        }
        return <span className="font-family-Montserrat-Regular">{fecha}</span>;
      },
    },
    {
      title: "Fecha cierre",
      width: 100,
      render: (datos) => {
        let fecha = datos.fechas;
        if (Array.isArray(datos.fechas)) {
          let fechacierre = datos.fechas.filter(
            (data) => data.clave === "Cierre"
          );
          if (fechacierre.length > 0) {
            fecha = fechacierre[0].valormin.substring(0, 10);
          }
        }
        return <span className="font-family-Montserrat-Regular">{fecha}</span>;
      },
    },
    {
      title: "Tipo participante",
      width: 100,
      render: (datos) => {
        if (Array.isArray(datos.tipo_participante)) {
          var tipo_participante = ""
          datos.tipo_participante.forEach((tipo) => {
            tipo_participante += tipo.text + " - ";
          });
        }
        return <span className="font-family-Montserrat-Regular">{tipo_participante}</span>;
      }
    },
    {
      title: "Estado",
      width: 100,
      render: (datos) => {
        let fecha = datos.fechas;
        if (Array.isArray(datos.fechas)) {
          let fechaCierre = datos.fechas.filter(
            (data) => data.clave === "Cierre"
          );

          if (fechaCierre.length > 0) {
            fecha = fechaCierre[0].valormax

            let fechaActual = new Date();
            let anio = fechaActual.getFullYear();
            let mes = ('0' + (fechaActual.getMonth() + 1)).slice(-2)
            let dia = ('0' + fechaActual.getDate()).slice(-2);
            let hora = ('0' + fechaActual.getHours()).slice(-2);
            let minutos = ('0' + fechaActual.getMinutes()).slice(-2);

            let fechaYHora = anio + '-' + mes + '-' + dia + ' ' + hora + ':' + minutos;

            let cierreAct = new Date(fecha);
            cierreAct.setHours(cierreAct.getHours() - 1);
            let anioc = cierreAct.getFullYear();
            let mesc = ('0' + (cierreAct.getMonth() + 1)).slice(-2);
            let diac = ('0' + cierreAct.getDate()).slice(-2);
            let horac = ('0' + cierreAct.getHours()).slice(-2);
            let minutosc = ('0' + cierreAct.getMinutes()).slice(-2);
            let fechaYHoraActualizada = anioc + '-' + mesc + '-' + diac + ' ' + horac + ':' + minutosc;

            if (fechaYHoraActualizada <= fechaYHora){
              var estadoAct = 'Cerrada'
            } else {
              estadoAct = datos.estado
            }
          }
        }
        return (<span style={{ color: coloresEstado[estadoAct], marginLeft: "0" }}>
                  {estadoAct}
                </span>)
      },
    },
    {
      title: "Entidad",
      width: 100,
      dataIndex: "entidad",
      key: "entidad",
    },
    {
      title: "Áreas",
      width: 200,
      render: (datos) => {
        if (Array.isArray(datos.area)) {
          let area = "";
          datos.area.forEach((tipo, index) => {
            area += tipo.text;
            if (index < datos.area.length - 1) {
              area += ", ";
            } else {
              area += ".";
            }
          });
          return <span className="font-family-Montserrat-Regular" style={{ whiteSpace: "pre-line" }}>{area}</span>;
        }
        return null;
      }
    }
  ];

  const handleRowClick = (record: any) => {
    window.open(`/estimuloscultura/verconvocatoria/${record.idconvocatorias}`, "_blank", "noopener,noreferrer")
  };
  // component mounted
  useEffect(() => {
    let mounted = true;
    if (mounted) {
      getConvocatorias();
    }
    return () => {
      mounted = false;
    };
  }, []);
  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  const content = (region) => {
    switch (region) {
      case "comuna90":
        return <p style={{color: 'orange', fontWeight: 'bold'}}>$ 258 598 794</p>;
      case "comuna1":
        return <p style={{color: 'orange', fontWeight: 'bold'}}>$ 100 256 667</p>;
      case "comuna2":
        return <p style={{color: 'orange', fontWeight: 'bold'}}>$ 336 525 162</p>;
      case "comuna5":
        return <p style={{color: 'orange', fontWeight: 'bold'}}>$ 226 838 878</p>;
      case "comuna6":
        return <p style={{color: 'orange', fontWeight: 'bold'}}>$ 314 005 334</p>;
      case "comuna60":
        return <p style={{color: 'orange', fontWeight: 'bold'}}>$ 232 910 238</p>;
      case "comuna50":
        return <p style={{color: 'orange', fontWeight: 'bold'}}>$ 36 000 000</p>;
      case "comuna3":
        return <p style={{color: 'orange', fontWeight: 'bold'}}>$ 582 506 094</p>;
      case "comuna4":
        return <p style={{color: 'orange', fontWeight: 'bold'}}>$ 279 644 918</p>;
      case "comuna7":
        return <p style={{color: 'orange', fontWeight: 'bold'}}>$ 464 157 697</p>;
      case "comuna8":
        return <p style={{color: 'orange', fontWeight: 'bold'}}>$ 382 715 401</p>;
      case "comuna9":
        return <p style={{color: 'orange', fontWeight: 'bold'}}>$ 280 252 250</p>;
      case "comuna10":
        return <p style={{color: 'orange', fontWeight: 'bold'}}>$ 2 051 095 348</p>;
      case "comuna11":
        return <p style={{color: 'orange', fontWeight: 'bold'}}>$ 2 051 095 348</p>;
      case "comuna12":
        return <p style={{color: 'orange', fontWeight: 'bold'}}>$ 614 022 535</p>;
      case "comuna13":
        return <p style={{color: 'orange', fontWeight: 'bold'}}>$ 230 163 167</p>;
      case "comuna14":
        return <p style={{color: 'orange', fontWeight: 'bold'}}>$ 889 564 805</p>;
      case "comuna15":
        return <p style={{color: 'orange', fontWeight: 'bold'}}>$ 47 729 960</p>;
      case "comuna16":
        return <p style={{color: 'orange', fontWeight: 'bold'}}>$ 932 006 550</p>;
      case "comuna70":
        return <p style={{color: 'orange', fontWeight: 'bold'}}>$ 121 643 167</p>;
      case "comuna80":
        return <p style={{color: 'orange', fontWeight: 'bold'}}>$ 94 793 334</p>;
      default:
        return <p style={{color: 'orange', fontWeight: 'bold'}}>Contenido no disponible</p>;
    }
  };

  const [visualizarAviso, setVisualizarAviso] = useState<boolean>(false);
  const [avisoInfo, setAvisoInfo] = useState<boolean>(false);


  const openModal = () => {
    setVisualizarAviso(true);
  }

  const [currentIndex, setCurrentIndex] = useState(0);

  const images = [abc1, abc2, abc3, abc4, abc5, abc6, abc7];

  const carouselRef = useRef<any>(null);

  const prevSlide = () => {
    carouselRef.current?.prev();
  };

  const nextSlide = () => {
    carouselRef.current?.next();
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 770);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 770);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div>
      <Header />
      <HeaderScc />
      <br />
      <div className="container-fluid2" style={{marginTop: '0'}}>
        <div>
          <div className="row justify-content-center text-center">
            <div id="mapContainer">
              <div className="font-family-Montserrat-Bold text-center font-color-black" style={{fontSize:64, position: 'relative', top: '24px'}}>
                <strong>
                  Medellín creativa
                </strong>
              </div>
              <img src={creativa} alt={'Economía creativa'} className="w-full h-auto" style={{ maxWidth: "60%"}}/>
            </div>
            <div id="mapContainerMovil">
              <div className="font-family-Montserrat-Bold text-center font-color-black" style={{fontSize:34, position: 'relative', top: '24px'}}>
                <strong>
                  Medellín creativa
                </strong>
              </div>
              <img src={creativa} style={{maxWidth: '100%'}} alt="Convocatorias - Estimulos cultura"></img>
            </div>
            <br />
            <div className="font-size-26px font-family-Montserrat text-center font-color-black">
              Fortalece tus proyectos artísticos y culturales
            </div>
            <br />
            <div className="font-family-Montserrat-Bold text-center font-color-black" style={{fontSize:29}}>
              <strong>
                ¡Participa en las convocatorias!
              </strong>
            </div>
          </div>
          <Form
              name="basic"
              size="large"
              layout="vertical"
              fields={fields}
              style={{
                border: '1px solid #ccc',
                borderRadius: '30px',
                padding: '30px',
                backgroundColor: 'white'
              }}
              onFieldsChange={async (_: any, fields: any) => {
                let infoupdate: any = { ...principalState.buscarconvocatorias };
                infoupdate[_[0].name[0]] = _[0].value;
                return setPrincipalState({ ...principalState, buscarconvocatorias: infoupdate });
              }}
          >
              <div className="row g-3 gb-0 mt-3 justify-content-center">
                {/*<div className="col-12 col-md-3 col-lg-3 mb-0 mt-0">
                    <Form.Item label="Nombre convocatoria" name="buscar_palabra_clave">
                      <Input style={{ width: "100%" }} placeholder="Nombre convocatoria" />
                    </Form.Item>
                </div>*/}
                <div className="col-12 col-md-5 col-lg-5 mb-0 mt-0">
                    <Form.Item label="Línea convocatoria" name="linea_convocatoria">
                      <Select
                          showSearch
                          optionFilterProp="children"
                          suffixIcon={<FlechaSelect />}
                          size="large"
                          style={{ width: "100%" }}
                          placeholder="Seleccionar..."
                      >
                          {principalState.linea_estrategicas
                            .slice()
                            .reverse()
                            .filter(({ nombre }: any) =>
                              !nombre.includes('- SM') && !nombre.includes('- MCM') && !nombre.includes('- PP') && !nombre.includes ('AGENDA CULTURAL')
                            )
                            .map(({ id, nombre }: any) => (
                              <Select.Option key={id} value={id}>
                                {nombre}
                              </Select.Option>
                          ))}
                      </Select>
                    </Form.Item>
                </div>
                <div className="col-6 col-md-4 col-lg-2 mb-0 mt-0">
                    <Form.Item label="Perfil" name="perfil_participante">
                      <Select allowClear placeholder="Seleccionar...">
                          {QuienParticipaOptions.map(({ value, text }, i) => (
                            <Select.Option key={i} value={value}>{text}</Select.Option>
                          ))}
                      </Select>
                    </Form.Item>
                </div>
                <div className="col-6 col-md-4 col-lg-2 mb-0 mt-0">
                    <Form.Item label="Área" name="area">
                      <Select dropdownMatchSelectWidth={false} allowClear placeholder="Seleccionar...">
                          {principalState.area.map(({ nombre }: any, i) => (
                            <Select.Option key={i} value={nombre}>{nombre}</Select.Option>
                          ))}
                      </Select>
                    </Form.Item>
                </div>
                <div className="col-6 col-md-2 col-lg-2 mb-0 mt-0">
                    <Button className="button-azul-ghost" style={{ marginTop: '20px'}} onClick={limipiarfiltros}>
                      Limpiar filtros
                    </Button>
                    <Button className="button-azul-radius" onClick={buscarconvocatorias}>
                      Buscar
                    </Button>
                </div>
                {/*<div className="col-6 col-md-4 col-lg-2 mb-0 mt-0">
                    <Form.Item label="Categoría" name="categoria_linea_convocatoria">
                      <Select dropdownMatchSelectWidth={false} disabled={principalState.categoria_linea_convocatorias.length < 1} allowClear placeholder="Seleccionar...">
                          {principalState.categoria_linea_convocatorias.map(({ id, nombre }) => (
                            <Select.Option key={id} value={id}>{nombre}</Select.Option>
                          ))}
                      </Select>
                    </Form.Item>
                </div>*/}
                {/*<div className="col-6 col-md-4 col-lg-2 mb-0 mt-0">
                    <Form.Item label="Tipo convocatoria" name="tipo_convocatoria">
                      <Select dropdownMatchSelectWidth={false} allowClear placeholder="Seleccionar...">
                          {tipoConvocatoria.map(({ value, text }: any, i) => (
                            <Select.Option key={i} value={value}>{text}</Select.Option>
                          ))}
                      </Select>
                    </Form.Item>
                </div>
                */}
                {/* <div className="col-6 col-md-4 col-lg-2 mb-0 mt-0">
                    <Form.Item label="Año" name="anio">
                      <Select dropdownMatchSelectWidth={false} allowClear placeholder="Seleccionar...">
                          {principalState.anios.map((year: any, i) => (
                            <Select.Option key={i} value={year}>{year}</Select.Option>
                          ))}
                      </Select>
                    </Form.Item>
                </div> */}
              </div>
          </Form>
          <br />
        </div>
      </div>

      <div className="container-fluid2">
        <div className="row g-3">
          <div className="col-12">
            {/* Botón para cambiar entre tabla y tarjetas */}
            <Button onClick={toggleVista}>
              {mostrarTabla ? 'Mostrar en tarjetas' : 'Mostrar en tabla'}
            </Button>
          </div>
        </div>
      </div>
      <br />
      <div id="convocatorias"></div>
      {mostrarTabla ? (
        <div className="container-fluid2" style={{height: "600px", overflowY: 'auto', border: '1px solid #ccc'}}>
          <div className="row g-3">
            <div className="col-12">
              <Table
                style={{ borderTop: "1px solid #C4C4C4", fontSize: '16px' }}
                locale={{ emptyText: <Empty description="No hay información para mostrar" style={{ padding: "50px" }} /> }}
                pagination={false}
                columns={columns}
                dataSource={datosTabla}
                size="middle"
                bordered={false}
                loading={loadingConvocatorias}
                onRow={(record) => {
                  return {
                    onClick: () => handleRowClick(record),
                    style: {
                      cursor: 'pointer',
                    },
                  }
                }}
              />
            </div>
          </div>
        </div>
        ) :
        <div className="container-fluid2" style={{height: "800px", overflowY: 'auto', border: '1px solid #ccc'}}>
          <div className="row g-3">
            {principalState.convocatoriasslice
            .filter((data: any) => data.entidad != "SM" && data.entidad != "MCM" && data.entidad != "PP" && data.entidad != "AGENDA CULTURAL") // Filtra solo las convocatorias con entidad "SM"
            .sort((a: any, b: any) => b.idconvocatorias - a.idconvocatorias) // Ordena por idconvocatorias
            .map((data: any, index: number) => (
              <div key={`contenedor_${index}`} className="col-12 col-md-3">
                <Cards key={index} convocatorias={data} />
              </div>
            ))}
          </div>
        </div>
      }

      {/*visibleButton &&
        <Buttonloadmore doFunction={() => getSiguientesConvocatorias()}/>
      */}
      <br />
      <br />
      <div className="container-fluid2">
        <div>
          <div className="row text-center">
            <span className="pb-3 font-size-30px font-family-Montserrat-SemiBold">
              Conoce nuestra{" "}
              <span className="font-family-Montserrat-Bold">
                gestión
              </span>
            </span>
          </div>
          <hr />
          <div className="carousel-container" style={divCarrusel}>
            <div className="carousel">
              <blockquote
                className="instagram-media mx-3 person-card"
                data-instgrm-permalink="https://www.instagram.com/reel/DIJQJtJMnv1/?utm_source=ig_web_button_native_share"
                data-instgrm-version="12"
                style={blockquoteStyle}
              >
                <div style={divStyle}>
                  <a
                    href="https://www.instagram.com/reel/DIJQJtJMnv1/?utm_source=ig_web_button_native_share"
                    style={linkStyle}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Ver esta publicación en Instagram
                  </a>
                </div>
              </blockquote>
              <blockquote
                className="instagram-media mx-3 person-card"
                data-instgrm-permalink="https://www.instagram.com/reel/DIMeNVwJsPw/?utm_source=ig_web_button_native_share"
                data-instgrm-version="12"
                style={blockquoteStyle}
              >
                <div style={divStyle}>
                  <a
                    href="https://www.instagram.com/reel/DIMeNVwJsPw/?utm_source=ig_web_button_native_share"
                    style={linkStyle}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Ver esta publicación en Instagram
                  </a>
                </div>
              </blockquote>
              <blockquote
                className="instagram-media mx-3 person-card"
                data-instgrm-permalink="https://www.instagram.com/reel/DIcTJpqBzCl/?utm_source=ig_web_button_native_share"
                data-instgrm-version="12"
                style={blockquoteStyle}
              >
                <div style={divStyle}>
                  <a
                    href="https://www.instagram.com/reel/DIcTJpqBzCl/?utm_source=ig_web_button_native_share"
                    style={linkStyle}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Ver esta publicación en Instagram
                  </a>
                </div>
              </blockquote>
              <blockquote
                className="instagram-media mx-3 person-card"
                data-instgrm-permalink="https://www.instagram.com/reel/DIeLKnWs7JL/?utm_source=ig_web_button_native_share"
                data-instgrm-version="12"
                style={blockquoteStyle}
              >
                <div style={divStyle}>
                  <a
                    href="https://www.instagram.com/reel/DIeLKnWs7JL/?utm_source=ig_web_button_native_share"
                    style={linkStyle}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Ver esta publicación en Instagram
                  </a>
                </div>
              </blockquote>
              <blockquote
                className="instagram-media mx-3 person-card"
                data-instgrm-permalink="https://www.instagram.com/reel/DIefxaDsc0I/?utm_source=ig_web_button_native_share"
                data-instgrm-version="12"
                style={blockquoteStyle}
              >
                <div style={divStyle}>
                  <a
                    href="https://www.instagram.com/reel/DIefxaDsc0I/?utm_source=ig_web_button_native_share"
                    style={linkStyle}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Ver esta publicación en Instagram
                  </a>
                </div>
              </blockquote>
              <blockquote
                className="instagram-media mx-3 person-card"
                data-instgrm-permalink="https://www.instagram.com/reel/DIulw3lOXFS/?utm_source=ig_web_button_native_share"
                data-instgrm-version="12"
                style={blockquoteStyle}
              >
                <div style={divStyle}>
                  <a
                    href="https://www.instagram.com/reel/DIulw3lOXFS/?utm_source=ig_web_button_native_share"
                    style={linkStyle}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Ver esta publicación en Instagram
                  </a>
                </div>
              </blockquote>
              <blockquote
                className="instagram-media mx-3 person-card"
                data-instgrm-permalink="https://www.instagram.com/reel/DIwMrnIOXa1/?utm_source=ig_web_button_native_share"
                data-instgrm-version="12"
                style={blockquoteStyle}
              >
                <div style={divStyle}>
                  <a
                    href="https://www.instagram.com/reel/DIwMrnIOXa1/?utm_source=ig_web_button_native_share"
                    style={linkStyle}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Ver esta publicación en Instagram
                  </a>
                </div>
              </blockquote>
              <blockquote
                className="instagram-media mx-3 person-card"
                data-instgrm-permalink="https://www.instagram.com/p/DI1_c6Qucef/?utm_source=ig_web_button_native_share"
                data-instgrm-version="12"
                style={blockquoteStyle}
              >
                <div style={divStyle}>
                  <a
                    href="https://www.instagram.com/p/DI1_c6Qucef/?utm_source=ig_web_button_native_share"
                    style={linkStyle}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Ver esta publicación en Instagram
                  </a>
                </div>
              </blockquote>
              <blockquote
                className="instagram-media mx-3 person-card"
                data-instgrm-permalink="https://www.instagram.com/reel/DJNKsPsyeiI/?utm_source=ig_web_button_native_share"
                data-instgrm-version="12"
                style={blockquoteStyle}
              >
                <div style={divStyle}>
                  <a
                    href="https://www.instagram.com/reel/DJNKsPsyeiI/?utm_source=ig_web_button_native_share"
                    style={linkStyle}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Ver esta publicación en Instagram
                  </a>
                </div>
              </blockquote>
              <blockquote
                className="instagram-media mx-3 person-card"
                data-instgrm-permalink="https://www.instagram.com/reel/DJRrF9qtpdH/?utm_source=ig_web_button_native_share"
                data-instgrm-version="12"
                style={blockquoteStyle}
              >
                <div style={divStyle}>
                  <a
                    href="https://www.instagram.com/reel/DJRrF9qtpdH/?utm_source=ig_web_button_native_share"
                    style={linkStyle}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Ver esta publicación en Instagram
                  </a>
                </div>
              </blockquote>
              <blockquote
                className="instagram-media mx-3 person-card"
                data-instgrm-permalink="https://www.instagram.com/reel/DJXd05VOh5o/?utm_source=ig_web_button_native_share"
                data-instgrm-version="12"
                style={blockquoteStyle}
              >
                <div style={divStyle}>
                  <a
                    href="https://www.instagram.com/reel/DJXd05VOh5o/?utm_source=ig_web_button_native_share"
                    style={linkStyle}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Ver esta publicación en Instagram
                  </a>
                </div>
              </blockquote>
              <blockquote
                className="instagram-media mx-3 person-card"
                data-instgrm-permalink="https://www.instagram.com/p/DIBvh7mRS8E/?utm_source=ig_web_button_native_share"
                data-instgrm-version="12"
                style={blockquoteStyle}
              >
                <div style={divStyle}>
                  <a
                    href="https://www.instagram.com/p/DIBvh7mRS8E/?utm_source=ig_web_button_native_share"
                    style={linkStyle}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Ver esta publicación en Instagram
                  </a>
                </div>
              </blockquote>
              <blockquote
                className="instagram-media mx-3 person-card"
                data-instgrm-permalink="https://www.instagram.com/p/DH_f-QZxdvw/?utm_source=ig_web_button_native_share"
                data-instgrm-version="12"
                style={blockquoteStyle}
              >
                <div style={divStyle}>
                  <a
                    href="https://www.instagram.com/p/DH_f-QZxdvw/?utm_source=ig_web_button_native_share"
                    style={linkStyle}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Ver esta publicación en Instagram
                  </a>
                </div>
              </blockquote>
              <blockquote
                className="instagram-media mx-3 person-card"
                data-instgrm-permalink="https://www.instagram.com/reel/DHwvdaLxuaD/?utm_source=ig_web_button_native_share"
                data-instgrm-version="12"
                style={blockquoteStyle}
              >
                <div style={divStyle}>
                  <a
                    href="https://www.instagram.com/reel/DHwvdaLxuaD/?utm_source=ig_web_button_native_share"
                    style={linkStyle}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Ver esta publicación en Instagram
                  </a>
                </div>
              </blockquote>
              <blockquote
                className="instagram-media mx-3 person-card"
                data-instgrm-permalink="https://www.instagram.com/reel/DHvqrJ8xI3a/?utm_source=ig_web_button_native_share"
                data-instgrm-version="12"
                style={blockquoteStyle}
              >
                <div style={divStyle}>
                  <a
                    href="https://www.instagram.com/reel/DHvqrJ8xI3a/?utm_source=ig_web_button_native_share"
                    style={linkStyle}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Ver esta publicación en Instagram
                  </a>
                </div>
              </blockquote>
              <blockquote
                className="instagram-media mx-3 person-card"
                data-instgrm-permalink="https://www.instagram.com/reel/DHeuwYbRRa7/?utm_source=ig_web_button_native_share"
                data-instgrm-version="12"
                style={blockquoteStyle}
              >
                <div style={divStyle}>
                  <a
                    href="https://www.instagram.com/reel/DHeuwYbRRa7/?utm_source=ig_web_button_native_share"
                    style={linkStyle}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Ver esta publicación en Instagram
                  </a>
                </div>
              </blockquote>
              <blockquote
                className="instagram-media mx-3 person-card"
                data-instgrm-permalink="https://www.instagram.com/reel/DHZrWEDxod-/?utm_source=ig_web_button_native_share"
                data-instgrm-version="12"
                style={blockquoteStyle}
              >
                <div style={divStyle}>
                  <a
                    href="https://www.instagram.com/reel/DHZrWEDxod-/?utm_source=ig_web_button_native_share"
                    style={linkStyle}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Ver esta publicación en Instagram
                  </a>
                </div>
              </blockquote>
              <blockquote
                className="instagram-media mx-3 person-card"
                data-instgrm-permalink="https://www.instagram.com/reel/DHJeB4UOyNp/?utm_source=ig_web_button_native_share"
                data-instgrm-version="12"
                style={blockquoteStyle}
              >
                <div style={divStyle}>
                  <a
                    href="https://www.instagram.com/reel/DHJeB4UOyNp/?utm_source=ig_web_button_native_share"
                    style={linkStyle}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Ver esta publicación en Instagram
                  </a>
                </div>
              </blockquote>
              <blockquote
                className="instagram-media mx-3 person-card"
                data-instgrm-permalink="https://www.instagram.com/reel/DHGhSSHuL1v/?utm_source=ig_web_button_native_share"
                data-instgrm-version="12"
                style={blockquoteStyle}
              >
                <div style={divStyle}>
                  <a
                    href="https://www.instagram.com/reel/DHGhSSHuL1v/?utm_source=ig_web_button_native_share"
                    style={linkStyle}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Ver esta publicación en Instagram
                  </a>
                </div>
              </blockquote>
              <blockquote
                className="instagram-media mx-3 person-card"
                data-instgrm-permalink="https://www.instagram.com/reel/DG4QB5OO4hQ/?utm_source=ig_web_button_native_share"
                data-instgrm-version="12"
                style={blockquoteStyle}
              >
                <div style={divStyle}>
                  <a
                    href="https://www.instagram.com/reel/DG4QB5OO4hQ/?utm_source=ig_web_button_native_share"
                    style={linkStyle}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Ver esta publicación en Instagram
                  </a>
                </div>
              </blockquote>
              <blockquote
                className="instagram-media mx-3 person-card"
                data-instgrm-permalink="https://www.instagram.com/reel/DG4CRSju1pE/?utm_source=ig_web_button_native_share"
                data-instgrm-version="12"
                style={blockquoteStyle}
              >
                <div style={divStyle}>
                  <a
                    href="https://www.instagram.com/reel/DG4CRSju1pE/?utm_source=ig_web_button_native_share"
                    style={linkStyle}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Ver esta publicación en Instagram
                  </a>
                </div>
              </blockquote>
              <blockquote
                className="instagram-media mx-3 person-card"
                data-instgrm-permalink="https://www.instagram.com/reel/DG3EbfsOx0G/?utm_source=ig_web_button_native_share"
                data-instgrm-version="12"
                style={blockquoteStyle}
              >
                <div style={divStyle}>
                  <a
                    href="https://www.instagram.com/reel/DG3EbfsOx0G/?utm_source=ig_web_button_native_share"
                    style={linkStyle}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Ver esta publicación en Instagram
                  </a>
                </div>
              </blockquote>
              <blockquote
                className="instagram-media mx-3 person-card"
                data-instgrm-permalink="https://www.instagram.com/reel/DG1diRsutW_/?utm_source=ig_web_button_native_share"
                data-instgrm-version="12"
                style={blockquoteStyle}
              >
                <div style={divStyle}>
                  <a
                    href="https://www.instagram.com/reel/DG1diRsutW_/?utm_source=ig_web_button_native_share"
                    style={linkStyle}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Ver esta publicación en Instagram
                  </a>
                </div>
              </blockquote>
              <blockquote
                className="instagram-media mx-3 person-card"
                data-instgrm-permalink="https://www.instagram.com/reel/DG0fufCOEbg/?utm_source=ig_web_button_native_share"
                data-instgrm-version="12"
                style={blockquoteStyle}
              >
                <div style={divStyle}>
                  <a
                    href="https://www.instagram.com/reel/DG0fufCOEbg/?utm_source=ig_web_button_native_share"
                    style={linkStyle}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Ver esta publicación en Instagram
                  </a>
                </div>
              </blockquote>
              <blockquote
                className="instagram-media mx-3 person-card"
                data-instgrm-permalink="https://www.instagram.com/reel/DGx62-cOKhn/?utm_source=ig_web_button_native_share"
                data-instgrm-version="12"
                style={blockquoteStyle}
              >
                <div style={divStyle}>
                  <a
                    href="https://www.instagram.com/reel/DGx62-cOKhn/?utm_source=ig_web_button_native_share"
                    style={linkStyle}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Ver esta publicación en Instagram
                  </a>
                </div>
              </blockquote>
              <blockquote
                className="instagram-media mx-3 person-card"
                data-instgrm-permalink="https://www.instagram.com/reel/DGieHWkOjzG/?utm_source=ig_web_button_native_share"
                data-instgrm-version="12"
                style={blockquoteStyle}
              >
                <div style={divStyle}>
                  <a
                    href="https://www.instagram.com/reel/DGieHWkOjzG/?utm_source=ig_web_button_native_share"
                    style={linkStyle}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Ver esta publicación en Instagram
                  </a>
                </div>
              </blockquote>
              <blockquote
                className="instagram-media mx-3 person-card"
                data-instgrm-permalink="https://www.instagram.com/p/DGdprbgxjd7/?utm_source=ig_web_button_native_share"
                data-instgrm-version="12"
                style={blockquoteStyle}
              >
                <div style={divStyle}>
                  <a
                    href="https://www.instagram.com/p/DGdprbgxjd7/?utm_source=ig_web_button_native_share"
                    style={linkStyle}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Ver esta publicación en Instagram
                  </a>
                </div>
              </blockquote>
              <blockquote
                className="instagram-media mx-3 person-card"
                data-instgrm-permalink="https://www.instagram.com/reel/DGTkQ_kvHB6/?utm_source=ig_web_button_native_share"
                data-instgrm-version="12"
                style={blockquoteStyle}
              >
                <div style={divStyle}>
                  <a
                    href="https://www.instagram.com/reel/DGTkQ_kvHB6/?utm_source=ig_web_button_native_share"
                    style={linkStyle}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Ver esta publicación en Instagram
                  </a>
                </div>
              </blockquote>
              <blockquote
                className="instagram-media mx-3 person-card"
                data-instgrm-permalink="https://www.instagram.com/reel/DGR0uoGo3im/?utm_source=ig_web_button_native_share"
                data-instgrm-version="12"
                style={blockquoteStyle}
              >
                <div style={divStyle}>
                  <a
                    href="https://www.instagram.com/reel/DGR0uoGo3im/?utm_source=ig_web_button_native_share"
                    style={linkStyle}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Ver esta publicación en Instagram
                  </a>
                </div>
              </blockquote>
              <blockquote
                className="instagram-media mx-3 person-card"
                data-instgrm-permalink="https://www.instagram.com/reel/DGBiCnxPFsb/?utm_source=ig_web_button_native_share"
                data-instgrm-version="12"
                style={blockquoteStyle}
              >
                <div style={divStyle}>
                  <a
                    href="https://www.instagram.com/reel/DGBiCnxPFsb/?utm_source=ig_web_button_native_share"
                    style={linkStyle}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Ver esta publicación en Instagram
                  </a>
                </div>
              </blockquote>
              <blockquote
                className="instagram-media mx-3 person-card"
                data-instgrm-permalink="https://www.instagram.com/reel/DF-h0UluDsQ/?utm_source=ig_web_button_native_share"
                data-instgrm-version="12"
                style={blockquoteStyle}
              >
                <div style={divStyle}>
                  <a
                    href="https://www.instagram.com/reel/DF-h0UluDsQ/?utm_source=ig_web_button_native_share"
                    style={linkStyle}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Ver esta publicación en Instagram
                  </a>
                </div>
              </blockquote>
              <blockquote
                className="instagram-media mx-3 person-card"
                data-instgrm-permalink="https://www.instagram.com/p/DF3D39exn8h/?utm_source=ig_web_button_native_share"
                data-instgrm-version="12"
                style={blockquoteStyle}
              >
                <div style={divStyle}>
                  <a
                    href="https://www.instagram.com/p/DF3D39exn8h/?utm_source=ig_web_button_native_share"
                    style={linkStyle}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Ver esta publicación en Instagram
                  </a>
                </div>
              </blockquote>
              <blockquote
                className="instagram-media mx-3 person-card"
                data-instgrm-permalink="https://www.instagram.com/p/DF8rFmRS6JL/?utm_source=ig_web_button_native_share"
                data-instgrm-version="12"
                style={blockquoteStyle}
              >
                <div style={divStyle}>
                  <a
                    href="https://www.instagram.com/p/DF8rFmRS6JL/?utm_source=ig_web_button_native_share"
                    style={linkStyle}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Ver esta publicación en Instagram
                  </a>
                </div>
              </blockquote>
              <blockquote
                className="instagram-media mx-3 person-card"
                data-instgrm-permalink="https://www.instagram.com/p/DFvI2JFRhbJ/?utm_source=ig_web_button_native_share"
                data-instgrm-version="12"
                style={blockquoteStyle}
              >
                <div style={divStyle}>
                  <a
                    href="https://www.instagram.com/p/DFvI2JFRhbJ/?utm_source=ig_web_button_native_share"
                    style={linkStyle}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Ver esta publicación en Instagram
                  </a>
                </div>
              </blockquote>
              <blockquote
                className="instagram-media mx-3 person-card"
                data-instgrm-permalink="https://www.instagram.com/reel/DFyTd7pyC6Z/?utm_source=ig_web_button_native_share"
                data-instgrm-version="12"
                style={blockquoteStyle}
              >
                <div style={divStyle}>
                  <a
                    href="https://www.instagram.com/reel/DFyTd7pyC6Z/?utm_source=ig_web_button_native_share"
                    style={linkStyle}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Ver esta publicación en Instagram
                  </a>
                </div>
              </blockquote>
              <blockquote
                className="instagram-media mx-3 person-card"
                data-instgrm-permalink="https://www.instagram.com/p/DF3D39exn8h/?utm_source=ig_web_button_native_share"
                data-instgrm-version="12"
                style={blockquoteStyle}
              >
                <div style={divStyle}>
                  <a
                    href="https://www.instagram.com/p/DF3D39exn8h/?utm_source=ig_web_button_native_share"
                    style={linkStyle}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Ver esta publicación en Instagram
                  </a>
                </div>
              </blockquote>
              <blockquote
                className="instagram-media mx-3 person-card"
                data-instgrm-permalink="https://www.instagram.com/reel/DFnYUbuR7rf/?utm_source=ig_web_button_native_share"
                data-instgrm-version="12"
                style={blockquoteStyle}
              >
                <div style={divStyle}>
                  <a
                    href="https://www.instagram.com/reel/DFnYUbuR7rf/?utm_source=ig_web_button_native_share"
                    style={linkStyle}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Ver esta publicación en Instagram
                  </a>
                </div>
              </blockquote>
              <blockquote
                className="instagram-media mx-3 person-card"
                data-instgrm-permalink="https://www.instagram.com/p/DFlhBWgyIip/?utm_source=ig_web_button_native_share"
                data-instgrm-version="12"
                style={blockquoteStyle}
              >
                <div style={divStyle}>
                  <a
                    href="https://www.instagram.com/p/DFlhBWgyIip/?utm_source=ig_web_button_native_share"
                    style={linkStyle}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Ver esta publicación en Instagram
                  </a>
                </div>
              </blockquote>
              <blockquote
                className="instagram-media mx-3 person-card"
                data-instgrm-permalink="https://www.instagram.com/reel/DFYs-44SLhb/?utm_source=ig_web_button_native_share"
                data-instgrm-version="12"
                style={blockquoteStyle}
              >
                <div style={divStyle}>
                  <a
                    href="https://www.instagram.com/reel/DFYs-44SLhb/?utm_source=ig_web_button_native_share"
                    style={linkStyle}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Ver esta publicación en Instagram
                  </a>
                </div>
              </blockquote>
              <blockquote
                className="instagram-media mx-3 person-card"
                data-instgrm-permalink="https://www.instagram.com/p/DE3PL3PR6v5/?utm_source=ig_web_button_native_share"
                data-instgrm-version="12"
                style={blockquoteStyle}
              >
                <div style={divStyle}>
                  <a
                    href="https://www.instagram.com/p/DE3PL3PR6v5/?utm_source=ig_web_button_native_share"
                    style={linkStyle}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Ver esta publicación en Instagram
                  </a>
                </div>
              </blockquote>
              <blockquote
                className="instagram-media mx-3 person-card"
                data-instgrm-permalink="https://www.instagram.com/reel/DCAeH9iS-mj/?utm_source=ig_web_button_native_share"
                data-instgrm-version="12"
                style={blockquoteStyle}
              >
                <div style={divStyle}>
                  <a
                    href="https://www.instagram.com/reel/DCAeH9iS-mj/?utm_source=ig_web_button_native_share"
                    style={linkStyle}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Ver esta publicación en Instagram
                  </a>
                </div>
              </blockquote>
              <blockquote
                className="instagram-media mx-3 person-card"
                data-instgrm-permalink="https://www.instagram.com/reel/DB1NKrOOUP5/?utm_source=ig_web_button_native_share"
                data-instgrm-version="12"
                style={blockquoteStyle}
              >
                <div style={divStyle}>
                  <a
                    href="https://www.instagram.com/reel/DB1NKrOOUP5/?utm_source=ig_web_button_native_share"
                    style={linkStyle}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Ver esta publicación en Instagram
                  </a>
                </div>
              </blockquote>
              <blockquote
                className="instagram-media mx-3 person-card"
                data-instgrm-permalink="https://www.instagram.com/reel/DBzmIHextJt/?utm_source=ig_web_button_native_share"
                data-instgrm-version="12"
                style={blockquoteStyle}
              >
                <div style={divStyle}>
                  <a
                    href="https://www.instagram.com/reel/DBzmIHextJt/?utm_source=ig_web_button_native_share"
                    style={linkStyle}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Ver esta publicación en Instagram
                  </a>
                </div>
              </blockquote>
              <blockquote
                className="instagram-media mx-3 person-card"
                data-instgrm-permalink="https://www.instagram.com/reel/DBJwwZ5RF-o/?utm_source=ig_web_button_native_share"
                data-instgrm-version="12"
                style={blockquoteStyle}
              >
                <div style={divStyle}>
                  <a
                    href="https://www.instagram.com/reel/DBJwwZ5RF-o/?utm_source=ig_web_button_native_share"
                    style={linkStyle}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Ver esta publicación en Instagram
                  </a>
                </div>
              </blockquote>
              <blockquote
                className="instagram-media mx-3 person-card"
                data-instgrm-permalink="https://www.instagram.com/reel/DBWZKsoO_zS/?utm_source=ig_web_button_native_share"
                data-instgrm-version="12"
                style={blockquoteStyle}
              >
                <div style={divStyle}>
                  <a
                    href="https://www.instagram.com/reel/DBWZKsoO_zS/?utm_source=ig_web_button_native_share"
                    style={linkStyle}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Ver esta publicación en Instagram
                  </a>
                </div>
              </blockquote>
              <blockquote
                className="instagram-media mx-3 person-card"
                data-instgrm-permalink="https://www.instagram.com/reel/DEU3ivFR-CD/?utm_source=ig_web_button_native_share"
                data-instgrm-version="12"
                style={blockquoteStyle}
              >
                <div style={divStyle}>
                  <a
                    href="https://www.instagram.com/reel/DEU3ivFR-CD/?utm_source=ig_web_button_native_share"
                    style={linkStyle}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Ver esta publicación en Instagram
                  </a>
                </div>
              </blockquote>
              <blockquote
                className="instagram-media mx-3 person-card"
                data-instgrm-permalink="https://www.instagram.com/p/DElV1uBxFr3/?utm_source=ig_web_button_native_share"
                data-instgrm-version="12"
                style={blockquoteStyle}
              >
                <div style={divStyle}>
                  <a
                    href="https://www.instagram.com/p/DElV1uBxFr3/?utm_source=ig_web_button_native_share"
                    style={linkStyle}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Ver esta publicación en Instagram
                  </a>
                </div>
              </blockquote>
              <blockquote
                className="instagram-media mx-3 person-card"
                data-instgrm-permalink="https://www.instagram.com/p/DE06EDyxgjw/?utm_source=ig_web_button_native_share"
                data-instgrm-version="12"
                style={blockquoteStyle}
              >
                <div style={divStyle}>
                  <a
                    href="https://www.instagram.com/p/DE06EDyxgjw/?utm_source=ig_web_button_native_share"
                    style={linkStyle}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Ver esta publicación en Instagram
                  </a>
                </div>
              </blockquote>
              <blockquote
                className="instagram-media mx-3 person-card"
                data-instgrm-permalink="https://www.instagram.com/reel/DE7m7pGRw6U/?utm_source=ig_web_button_native_share"
                data-instgrm-version="12"
                style={blockquoteStyle}
              >
                <div style={divStyle}>
                  <a
                    href="https://www.instagram.com/reel/DE7m7pGRw6U/?utm_source=ig_web_button_native_share"
                    style={linkStyle}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Ver esta publicación en Instagram
                  </a>
                </div>
              </blockquote>
            </div>
          </div>
          <br />
          <br />
          <div className="row text-center">
            <span className="pb-3 font-size-30px font-family-Montserrat-SemiBold">
              Conoce cómo inscribirte{" "}
              <span className="font-family-Montserrat-Bold">
                y quiénes lo han logrado
              </span>
            </span>
          </div>
          <hr />
          <div className="row">
            <div className="col-12 col-md-6 col-sm-6">
              <br />
              <div className="font-size-16px font-family-Montserrat-Bold text-center font-color-black">
                Tutorial de cómo gestionar y recuperar la clave:
              </div>
              <br />
              <iframe src="https://www.youtube.com/embed/Lo5VZP6jYnA?si=wP0B9Mt6YoYCOD0c"
                title="YouTube video player"
                style={{width: '100%', height:'400px'}}
                >
              </iframe>
            </div>
            <div className="col-12 col-md-6 col-sm-6">
              <br />
              <div className="font-size-16px font-family-Montserrat-Bold text-center font-color-black">
                Tutorial de cómo inscribir un proyecto:
              </div>
              <br />
              <iframe src="https://www.youtube.com/embed/MfTlS1KKUKE?si=kPvxE4Ca3uYB-Oqp"
                title="YouTube video player"
                style={{width: '100%', height:'400px'}}
                >
              </iframe>
            </div>
          </div>
          <br />
          <br />
          <div className="row text-center">
            <span className="pb-3 font-size-30px font-family-Montserrat-SemiBold">
                ABECÉ Convocatorias de{" "}
              <span className="font-family-Montserrat-Bold">
                Fomento y Estímulos para el Arte y la Cultura
              </span>
            </span>
          </div>
          <hr />
          <div className="row flex flex-row justify-center items-center" style={{textAlign: 'justify'}}>
            <div>
              <Carousel></Carousel>
            </div>
            <br />
            <br />
            <div className="row" style={{textAlign: 'justify', marginTop:'5'}}>
            </div>
            <br />
            <div className="row text-center">
              {/*<span id="mapContainer" className="pb-3 font-size-20px font-family-Montserrat-SemiBold">
                Mueve el cursor por el mapa para conocer la inversión por comuna en el año 2024
              </span>*/}
            </div>
             {/*
            <div className="row text-center" id="mapContainer">
              <span className="pb-3 font-size-30px font-family-Montserrat-Semi  Bold">
                ¡Gracias a las convocatorias lo hacemos posible!
              </span>
              <br />
              <img src={mapaCifras} style={{maxWidth: '100%'}} alt="Inversion comunas"></img>
            </div>
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <div className="map-container" id="mapContainer" style={{ width: '1100px', margin: '0 auto'}}>
              <Space wrap>
                <Popover content={content("comuna90")} title="Comuna 90 (Santa Elena)" trigger="hover" placement="right">
                  <img src={Comuna90} className="region" alt="comuna 90" style={{top: '-10%', right: '2%', width: '40%', pointerEvents: 'visiblePainted'}}></img>
                </Popover>
                <Popover content={content("comuna1")} title="Comuna 1 (Popular)" trigger="hover" placement="right">
                  <img src={Comuna1} className="region" alt="comuna 1" style={{top: '-12%', right: '30%', width: '9%', pointerEvents: 'visiblePainted'}}></img>
                </Popover>
                <Popover content={content("comuna2")} title="Comuna 2 (Santa Cruz)" trigger="hover" placement="right">
                  <img src={Comuna2} className="region" alt="comuna 2" style={{top: '-18%', right: '33%', width: '9%', pointerEvents: 'visiblePainted'}}></img>
                </Popover>
                <Popover content={content("comuna5")} title="Comuna 5 (Castilla)" trigger="hover" placement="right">
                  <img src={Comuna5} className="region" alt="comuna 5" style={{top: '-21%', right: '41%', width: '11%', pointerEvents: 'visiblePainted'}}></img>
                </Popover>
                <Popover content={content("comuna6")} title="Comuna 6 (Doce de Octubre)" trigger="hover" placement="right">
                  <img src={Comuna6} className="region" alt="comuna 6" style={{top: '-22%', right: '46%', width: '10%', pointerEvents: 'visiblePainted'}}></img>
                </Popover>
                <Popover content={content("comuna60")} title="Comuna 60 (San Critóbal)" trigger="hover" placement="right">
                  <img src={Comuna60} className="region" alt="comuna 60" style={{top: '-33%', right: '53%', width: '40%', pointerEvents: 'visiblePainted'}}></img>
                </Popover>
                <Popover content={content("comuna50")} title="Comuna 50 (San Sebastián de Palmitas)" trigger="hover" placement="right">
                  <img src={Comuna50} className="region" alt="comuna 50" style={{top: '-36%', left: '0%', width: '17%', pointerEvents: 'visiblePainted'}}></img>
                </Popover>
                <Popover content={content("comuna3")} title="Comuna 3 (Manrique)" trigger="hover" placement="right">
                  <img src={Comuna3} className="region" alt="comuna 3" style={{top: '2%', right: '28%', width: '11%', pointerEvents: 'visiblePainted'}}></img>
                </Popover>
                <Popover content={content("comuna4")} title="Comuna 4 (Aranjuez)" trigger="hover" placement="right">
                  <img src={Comuna4} className="region" alt="comuna 4" style={{top: '-2%', right: '37%', width: '9%', pointerEvents: 'visiblePainted'}}></img>
                </Popover>
                <Popover content={content("comuna7")} title="Comuna 7 (Robledo)" trigger="hover" placement="right">
                  <img src={Comuna7} className="region" alt="comuna 7" style={{top: '-6%', right: '48%', width: '21%', pointerEvents: 'visiblePainted'}}></img>
                </Popover>
                <Popover content={content("comuna8")} title="Comuna 8 (Villa Hermosa)" trigger="hover" placement="right">
                  <img src={Comuna8} className="region" alt="comuna 8" style={{top: '22%', right: '25%', width: '16%', pointerEvents: 'visiblePainted'}}></img>
                </Popover>
                <Popover content={content("comuna9")} title="Comuna 9 (Buenos Aires)" trigger="hover" placement="right">
                  <img src={Comuna9} className="region" alt="comuna 9" style={{top: '34%', right: '24%', width: '20%', pointerEvents: 'visiblePainted'}}></img>
                </Popover>
                <Popover content={content("comuna10")} title="Comuna 10 (La Candelaria)" trigger="hover" placement="right">
                  <img src={Comuna10} className="region" alt="comuna 10" style={{top: '20%', right: '38%', width: '11%', pointerEvents: 'visiblePainted'}}></img>
                </Popover>
                <Popover content={content("comuna11")} title="Comuna 11 (Laureles Estadio)" trigger="hover" placement="right">
                  <img src={Comuna11} className="region" alt="comuna 11" style={{top: '14%', right: '50%', width: '15%', pointerEvents: 'visiblePainted'}}></img>
                </Popover>
                <Popover content={content("comuna12")} title="Comuna 12 (La América)" trigger="hover" placement="right">
                  <img src={Comuna12} className="region" alt="comuna 12" style={{top: '12%', right: '57%', width: '10%', pointerEvents: 'visiblePainted'}}></img>
                </Popover>
                <Popover content={content("comuna13")} title="Comuna 13 (San Javier)" trigger="hover" placement="right">
                  <img src={Comuna13} className="region" alt="comuna 13" style={{top: '10%', left: '28%', width: '14%', pointerEvents: 'visiblePainted'}}></img>
                </Popover>
                <Popover content={content("comuna14")} title="Comuna 14 (El Poblado)" trigger="hover" placement="right">
                  <img src={Comuna14} className="region" alt="comuna 14" style={{top: '46%', right: '34%', width: '16%', pointerEvents: 'visiblePainted'}}></img>
                </Popover>
                <Popover content={content("comuna15")} title="Comuna 15 (Guayabal)" trigger="hover" placement="right">
                  <img src={Comuna15} className="region" alt="comuna 15" style={{top: '39%', right: '50%', width: '11%', pointerEvents: 'visiblePainted'}}></img>
                </Popover>
                <Popover content={content("comuna16")} title="Comuna 16 (Belén)" trigger="hover" placement="right">
                  <img src={Comuna16} className="region" alt="comuna 16" style={{top: '34%', right: '50%', width: '19%', pointerEvents: 'visiblePainted'}}></img>
                </Popover>
                <Popover content={content("comuna70")} title="Comuna 70 (Altavista)" trigger="hover" placement="right">
                  <img src={Comuna70} className="region" alt="comuna 70" style={{top: '19%', right: '58%', width: '28%', pointerEvents: 'visiblePainted'}}></img>
                </Popover>
                <Popover content={content("comuna80")} title="Comuna 80 (San Antonio de Prado)" trigger="hover" placement="right">
                  <img src={Comuna80} className="region" alt="comuna 80" style={{top: '9%', left: '2%', width: '21%', pointerEvents: 'visiblePainted'}}></img>
                </Popover>
                <img src={Rio} className="rio" alt="rio de medellin" style={{top: '-20%', left: '47%', width: '14%'}}></img>
              </Space>
              <br />
              <br />
            </div>
            <div id="mapContainer" className="row text-center" style={{display: 'flex', justifyContent: 'center'}}>
              <Button className="button-azul-radius font-family-Montserrat-SemiBold" style={{width: 'auto'}} onClick={openModal}>
                Inversión por áreas
              </Button>
            </div>
            */}

          </div>
        </div>
      </div>
      <br />
      <br />
      <div className="row">
        {"  "}
      </div>
      <ModalVisualizarInversion
          visualizar={visualizarAviso}
          setVisualizar={setVisualizarAviso}
        />
      <ModalAvisoInfo
        visualizar={avisoInfo}
        setVisualizar={setAvisoInfo}
      />
      <br />
      <Footer />
    </div>
  );
};
